import Footer from "../Footer/Footer";
import "./ReturnPolicy.css"
import Header from "../Header/Navbar"


const ReturnPolicyPage: React.FC= () => {
  return (
    <>
  
    <div className="returnPolicySection">
      <h2>Returns, Refunds, Cancellation & Exchange Policy</h2>
      <p style={{ marginLeft: "10px" }}>
        Any cancellations, returns, or exchanges are governed by this policy.
      </p>

      <h3>1. General Policy</h3>
      <ul>
        <li>Currently, we do not entertain claims for returns or exchanges in general.</li>
      </ul>

      <h3>2. Cancellations</h3>
      <ul>
        <li>Orders once placed and confirmed cannot be cancelled.</li>
        <li>You may contact us for cancellation requests before shipment.</li>
        <li>Cancellation approval is at our sole discretion.</li>
      </ul>

      <h3>3. Refunds</h3>
      <ul>
        <li>If approved, refunds will be processed to your original payment method within 15 days.</li>
        <li>For delays or issues, contact our customer support.</li>
      </ul>

      <h3>4. Return or Exchange</h3>
      <ul>
        <li>Returns or exchanges are allowed within 2 days from the date of delivery.</li>
        <li>This applies only to purchases made through our online store.</li>
        <li>Return or exchange is at our discretion based on your request.</li>
      </ul>

      <h3>5. Contact Us</h3>
      <ul>
        <li>Email: <a href="mailto:customer.care@gangasupermarket.in">customer.care@gangasupermarket.in</a></li>
        <li>WhatsApp: +91-9043426746</li>
        <li>Address: 4/426-HA, Ganga Nagar, Thuraiyur Road, Namakkal, TN-India</li>
        <li>In case of no response, you may contact Ganga Supermarket / Planet Enterprises CEO</li>
      </ul>
    </div>
    <Footer/>
    </>
  );
};

export default ReturnPolicyPage;
